<template>
  <div class="agency-contact-embedded section">
    <div class="section__wrapper">
      <agency-contact-banner class="show-on-mobile" :heading="heading" :text="text"></agency-contact-banner>

      <!-- Note: don't remove id - it is used as a hash anchorpoint -->
      <div id="contact" class="agency-contact-embedded__form">
        <agency-contact :embedded-form="true" :form-version="formVersion"></agency-contact>
      </div>
      <div v-if="heading && text" class="agency-contact-embedded__banner show-on-desktop">
        <agency-contact-banner :heading="heading" :text="text"></agency-contact-banner>
      </div>
    </div>
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';

export default {
  name: 'agency-contact-embedded',
  props: {
    heading: {
      type: String,
      required: false,
    },
    text: {
      type: String,
      required: false,
    },
    formVersion: {
      type: String,
      required: false,
    },
  },
  components: {
    AgencyContactBanner: defineAsyncComponent(
      () => import('@/app/components/agency-contact-embedded/agency-contact-banner.vue')
    ),
    AgencyContact: defineAsyncComponent(() => import('@/app/components/agency-contact/agency-contact.vue')),
    Dialogue: defineAsyncComponent(() => import('@/app/components/dialogue/dialogue.vue')),
  },
  mounted() {
    this.$bus.$emit('agency-contact-emdedded-ready');
  },
};
</script>
